const FLASH_MESSAGE_TIMEOUT = 3000 // messages stay up to 3 seconds on the screen

var defaultState = {
  timeoutId: null,
  message: null,
  modalMessage: null
}

export const mutations = {
  setMessage (state, { message, timeoutId }) {
    state.message = message
    state.timeoutId = timeoutId
  },
  setModalMessage (state, message) {
    state.modalMessage = message
  }
}

export const getters = {
  flashMessage: state => state.message,
  modalMessage: state => state.modalMessage
}

export const actions = {
  showMessage ({ state, commit }, message) {
    if (state.timeoutId !== null) {
      clearTimeout(state.timeoutId)
    }

    let timeoutId = setTimeout(() => {
      commit('setMessage', { message: null, timeoutId: null })
    }, FLASH_MESSAGE_TIMEOUT)

    commit('setMessage', { message, timeoutId })
  },
  showModal ({ state, commit }, message) {
    commit('setModalMessage', message)
  },
  hideModal ({ state, commit }) {
    commit('setModalMessage', null)
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/flash.js